import { Pagination } from "@customTypes/index";


export const PAGE_TITLE = "La Ruche Health EMR";

export const LARUCHE_IDENTIFIER = "LaR";

export const MEGABYTE = 1024 * 1024;

export const AUTO_GENERATED_FILENAME = "generated_medication";

export const MAX_FILENAME_LENGTH_BEFORE_UPLOAD = 28; // file name will contain file size, so this has to be a bit shorter

export const MAX_FILENAME_LENGTH_AFTER_UPLOAD = 32;

export const DEFAULT_PAGINATION: Pagination = {
  page: 1, //* This has to be 1 (and not 0) to trigger refetching in useEffect conditions
  pageSize: import.meta.env.DEV ? 25 : 25,
  pageCount: 1,
  total: 0, //* This has to be 0 to avoid the inaccuracy of "Displaying 0 out of 1 rows"
};

export const MAX_PAGE_SIZE = 1000;

export const AUTO_CLOSE = 1000 * 4; // Time for notifications to disappear in milliseconds

export const IDLE_WARNING_DELAY = import.meta.env.DEV
  ? 1000 * 60 * 30
  : 1000 * 60 * 8; // 8 minutes till modal warning is triggered- User did nothing for 8 minutes straight
export const IDLE_SIGN_OUT_DELAY = import.meta.env.DEV
  ? 1000 * 60 * 5
  : 1000 * 60 * 2; // 2 minutes till auto sign out - User still did nothing for a total of 10 minutes

export const Z_INDEX = {
  LEVEL_1: 9, // default
  LEVEL_2: 99,
  LEVEL_3: 999,
  LEVEL_4: 9999,
  LEVEL_5: 99999,
  LEVEL_6: 999999,
} as const;

export const QP = {
  PAGE: "page", // or "pg"
  SEARCH: "search", // or "q"
  // PAGE_SIZE: "pageSize",  // or "pgSz"
  STATUS: "status", // or "stat"
  CATEGORY: "category", // or "cat"
  TAB: "tab",
  CID: "cId", // Consultation Id (Human readable version, Eg: C-PGB9K)
  YEAR: "yr",
  MONTH: "mo",
  DAY: "day",
  SORT: "sort",
  FILTER: "flt",
} as const;

export const ROLES = {
  ADMIN: "admin",
  DOCTOR: "doctor",
  NURSE: "nurse",
  RECEPTIONIST: "receptionist",
  EXTERNAL_TESTER: "external_tester",
  INTERNAL_TESTER: "internal_tester",
} as const;

export const SESSION_STORAGE_KEYS = {
  // Video call
  VC_THRESHOLD: "t_1",
  VC_DOCTOR_JOINED: "d_j",
  VC_PATIENT_JOINED: "p_j",
  VC_CALL_DURATION_WITH_PATIENT: "c_d",
} as const;

export const LOCAL_STORAGE_KEYS = {
  LARUCHE_IDENTIFIER: "LaR", //? Just leave this as a stand-alone?
} as const;

export const VIDEO_CALL_THRESHOLD = {
  doctorJoined: false,
  patientJoined: false,
  callDuration: 0,
};
